import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import queryString from "query-string"
import React, { useEffect, useState } from "react"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { useSelector, useDispatch } from "react-redux"
import { changePassword } from "../../clientServices/authService"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import { getValidRedirectUrls } from "../../appRedux/slices/currentUser"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

import { withRouter, Link, useLocation } from "react-router-dom"

// import images
import logo from "../../assets/images/logo.svg"

const ChangePassword = props => {
  const dispatch = useDispatch()
  const search = useLocation().search
  const path = new URLSearchParams(search).get("path")
  const email = new URLSearchParams(search).get("email")

  const { isValidRedirectUrl, loading, urlLoading } = useSelector(state => ({
    isValidRedirectUrl: _.get(state, "currentUser.isValidRedirectUrl"),
    loading: _.get(state, "currentUser.loading"),
    urlLoading: _.get(state, "currentUser.urlLoading"),
  }))

  useEffect(async () => {
    if (!urlLoading && path != null) {
      let isValidUrl = dispatch(getValidRedirectUrls({ path }))
    }
  }, [urlLoading])

  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    try {
      const response = await changePassword(values)
      if (response.status && response.status === 200) {
        toastr.success(
          _.get(response, "data.message") || "Change Password Successfully."
        )
        if (path != null) {
          window.location.assign(path)
        } else {
          window.location.assign(`${window.location.origin}/dashboard/home`)
        }
      } else {
        toastr.error(
          _.get(response, "response.data.message") || "Something went wrong.",
          ""
        )
      }
    } catch (error) {
    } finally {
    }
  }

  const pwValidation = (value, ctx) => {
    if (!ctx.newPassword) {
      return false
    }
    if (ctx.password === ctx.newPassword) {
      return "Old Password and New Password can not be same."
    }
    return true
  }

  return (
    <>
    {((isValidRedirectUrl && path != null) || (path == null)) ? (
      <Container className="center_div">
        <MetaTags>
          <title>Change Password | Josh Central Authentication System</title>
        </MetaTags>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2" />
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col xs={7}>
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Welcome !!</h5>
                          <p>Change Password.</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div>
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="px-2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v)
                        }}
                      >
                        {/* {error ? <Alert color="danger">{error}</Alert> : null} */}

                        <div className="mb-3">
                          <AvField
                            name="email"
                            label="Email"
                            value={email || ""}
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="password"
                            label="Current Password"
                            value=""
                            type="password"
                            required
                            placeholder="Enter Current Password"
                          />
                        </div>

                        <div className="mb-3">
                          <AvField
                            name="newPassword"
                            label="New Password"
                            value=""
                            type="password"
                            required
                            placeholder="Enter New Password"
                            validate={{ pwValidation: pwValidation }}
                          />
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block py-2"
                            type="submit"
                          >
                            Set Password
                          </button>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    © {new Date().getFullYear()} Central Authorization Tool
                    <i className="mdi mdi-heart text-danger" />
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
     ) :  <div className="font-size-16 text-center text-muted font_italic_bold center_div">
     Invalid redirect URL
     </div>}
    </>
  )
}

export default withRouter(ChangePassword)

ChangePassword.propTypes = {
  history: PropTypes.object,
}
